import { Card, Form } from "react-bootstrap";
import CustomerAddress from "./CustomerAddress";
import CompanyForm from "./CompanyForm";
import { useState } from "react";
import { orderAtom } from "../atoms/atoms";
import { useSetAtom } from "jotai";

const InvoiceForm = () => {

    const [showInvoice, setShowInvoice] = useState(false);
    const setOrder = useSetAtom(orderAtom);

    const onShowInvoiceChange = (e) => {
        setShowInvoice(e.target.checked);
        setOrder((prev) => ({
            ...prev,
            needInvoice: e.target.checked,
        }));
    }

    return (
        <>
        <Form.Check // prettier-ignore
                            type="switch"
                            id="invoice-switch"
                            label="Potrzebuję fakturę VAT"
                            onChange={(e) => {
                                onShowInvoiceChange(e);
                              }}
                        />
        {showInvoice && (<>
         <Card.Title>Dane do faktury</Card.Title>
         <CompanyForm />
        <CustomerAddress />
        <div className="text-muted text-center">
            <small>
            Kontynuacja zakupu oznacza zgodę na przesłanie faktury VAT w formie elektronicznej - na podstawie § 3 Rozporządzenia Ministra Finansów z dnia 17.12.2010 r. (Dz. U. z 2010 r. nr 249, poz. 1661) .
            </small>
        </div>
        </>)}
        </>
    );
}

export default InvoiceForm;